import { IconBtn } from 'ctls/inputs/IconBtn';
import { tc } from 'language/i18nkey';
import styled from 'styled-components';
import { DiffLevel } from './useApiDocGrp';

export const PopDocGrpSettTitle = ({ onClose, diffLevel }: { diffLevel: DiffLevel; onClose: () => void }) => {
  const getClassName = () => {
    if (diffLevel === 'Same') return 'same';
    if (diffLevel === 'Different' || diffLevel === 'Similar') return 'different';
    return '';
  };
  const getText = () => {
    if (diffLevel === 'Same') return tc('i18n_same');
    if (diffLevel === 'Different') return tc('i18n_different');
    if (diffLevel === 'Similar') return tc('i18n_different');
    return '';
  };
  return (
    <DlgTitle>
      <span>{tc('i18n_doc_grp_sett_title')}</span>

      {diffLevel !== undefined && <DocStat className={getClassName()}>{getText()}</DocStat>}
      <CloseBtn btnType='close' onClick={onClose} />
    </DlgTitle>
  );
};

const DocStat = styled.div`
  font-size: 1.2rem;
  border-radius: 2rem;
  width: 6.1rem;
  line-height: 3.2rem;
  text-align: center;
  margin-left: 1.6rem;

  &.same {
    color: #34a597;
    border: 1px solid #34a597;
    background-color: #34a5971a;
  }

  &.different {
    color: #e6003e;
    border: 1px solid #e6003e;
    background-color: #e6003e1a;
  }
`;

const DlgTitle = styled.div`
  font-size: 2.4rem;
  display: flex;
  align-items: center;
  font-weight: 700;
  color: #2a2c2f;
  padding: 3.6rem 3.2rem 0 3.2rem;
`;

const CloseBtn = styled(IconBtn)`
  position: absolute;
  top: 1.6rem;
  right: 1.6rem;
  width: 2.4rem;
  height: 2.4rem;
`;
